export default __webpack_public_path__ + "static/media/modal03.bde3984a.png";